import { useState } from "react";
import { CheckSquare, Loader2, Square, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const CONSENTS = ["contract", "clauses", "privacy"];
const isHeading = (l) => /^\d+\.\s/.test(l) || /^[A-ZÀ-Ü0-9 &'’,.()\-—"/]{12,}:?$/.test(l);

export default function ContractDialog({ contract, onClose, onAccept }) {
  const { t } = useI18n();
  const [checked, setChecked] = useState({});
  const all = CONSENTS.every((k) => checked[k]);
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end md:items-center justify-center" onClick={onClose}>
      <div data-testid="contract-dialog" onClick={(e) => e.stopPropagation()} className="bg-white w-full md:max-w-2xl h-[92vh] md:h-[85vh] rounded-t-3xl md:rounded-3xl flex flex-col mn-rise">
        <div className="flex items-center px-5 h-14 border-b border-[var(--border)]">
          <h2 className="flex-1 text-lg font-extrabold">{t("contract_title")}</h2>
          <button data-testid="contract-close" onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[var(--surface-2)]"><X /></button>
        </div>
        {!contract ? (
          <div className="flex-1 flex items-center justify-center"><Loader2 className="animate-spin" color="var(--brand-primary)" /></div>
        ) : (
          <div data-testid="contract-text" className="flex-1 overflow-y-auto p-5 flex flex-col gap-2">
            {contract.lines.map((l, i) => (
              <p key={i} className={i === 0 ? "text-base font-extrabold" : isHeading(l) ? "text-sm font-extrabold mt-2" : "text-[13px] leading-5 text-[#1c1c1e]"}>{l}</p>
            ))}
          </div>
        )}
        <div className="p-5 border-t border-[var(--border)] flex flex-col gap-3">
          {CONSENTS.map((k) => (
            <button key={k} data-testid={`contract-consent-${k}`} role="checkbox" aria-checked={!!checked[k]}
              onClick={() => setChecked((p) => ({ ...p, [k]: !p[k] }))} className="flex gap-2.5 items-start text-left">
              {checked[k] ? <CheckSquare className="shrink-0" color="var(--brand-primary)" /> : <Square className="shrink-0" color="#c7c7cc" />}
              <span className="text-[13px] leading-[18px]">{t(`consent_${k}`)}</span>
            </button>
          ))}
          <button data-testid="contract-accept" className="mn-btn" disabled={!all || !contract} onClick={onAccept}>{t("contract_accept")}</button>
        </div>
      </div>
    </div>
  );
}
